<template>
	<page-container :page="page">
		<video-header v-if="page.vimeoIDLandscape" :embed-code="page.vimeoIDLandscape" type="large">
			<template #heroContent>
				<div v-if="defaults[locale].homepage.headingTitle" class="hero-content">
					<span class="hero-title">
						{{ defaults[locale].homepage.headingTitle }}
					</span>
					<span class="hero-subtitle">
						{{ defaults[locale].homepage.headingSubTitle }}
					</span>
				</div>
			</template></video-header
		>
		<heading-image
			v-else-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		>
			<template #heroContent>
				<div v-if="defaults[locale].homepage.headingTitle" class="hero-content">
					<span class="hero-title">
						{{ defaults[locale].homepage.headingTitle }}
					</span>
					<span class="hero-subtitle">
						{{ defaults[locale].homepage.headingSubTitle }}
					</span>
				</div>
			</template>
		</heading-image>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		>
			<template #bgImage>
				<picture>
					<source srcset="/images/star-bg.svg" />
					<img
						class="fade-image-intro"
						src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciLz4="
						alt="Booking benefits"
						loading="lazy"
					/>
				</picture>
			</template>
		</main-content>

		<hotels-promoblocks
			:items="roomsData"
			:header="defaults[locale].homepage.sectionHotelsTitle"
			:subtitle="defaults[locale].homepage.sectionHotelsSubtitle"
			:more-button-label="defaults[locale].homepage.sectionHotelsButtonLabel"
			:eventblocks="eventsData"
			:amount="12"
		/>

		<eventblocks
			:header="defaults[locale].homepage.sectionEventsTitle"
			:subtitle="defaults[locale].homepage.sectionEventsSubtitle"
			:more-button-label="defaults[locale].homepage.sectionEventsButtonLabel"
			:eventblocks="eventsData"
			:amount="4"
		/>

		<promoblocks
			:header="defaults[locale].homepage.sectionPromoblocksTitle"
			:subtitle="defaults[locale].homepage.sectionPromoblocksSubtitle"
			:more-button-label="defaults[locale].homepage.sectionPromoblocksButtonLabel"
			:promoblocks="promoblocksData"
			:amount="4"
		/>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksSubtitle"
			:content-blocks-title="page.sectionContentblocksTitle"
		/>

		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>

		<news-overview :news="news" />
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: promoblocksData } = await useWebsiteFetch('promoblocks', {
	query: { language: locale.value },
	key: `${locale.value}/promoblocks`,
});

const { data: eventsData } = await useWebsiteFetch('events', {
	query: { language: locale.value },
	key: `${locale.value}/events`,
});

const { data: news } = await useWebsiteFetch('news', {
	api: 'group',
	query: { language: locale.value },
	key: `${locale.value}/news`,
});
const { data: roomsData } = await useWebsiteFetch('hotels', {
	query: { language: locale.value },
	key: `${locale.value}/hotels`,
});
</script>
